import { logger as LOG } from '@sg/garnish';

// ─── Logger ──────────────────────────────────────────────────────────────────

// NOTE: Uncomment `LOG.enable` to enable logging

/// LOG.enable('LAUNCHDARKLY');
export const logger = LOG.extend('LAUNCHDARKLY');
